"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_CODE = exports.DETAILED_ACTION_CODE = exports.DETAILED_ACTION_TYPE = exports.DETAILED_OBJECT_CATEGORY = exports.ACTION_TYPE = exports.OBJECT_CATEGORY = void 0;
var OBJECT_CATEGORY;
(function (OBJECT_CATEGORY) {
    OBJECT_CATEGORY["MOB_USER"] = "MOB_USER";
    OBJECT_CATEGORY["WEB_USER"] = "WEB_USER";
    OBJECT_CATEGORY["LIST"] = "LIST";
    OBJECT_CATEGORY["ITEM"] = "ITEM";
    OBJECT_CATEGORY["CLIENT"] = "CLIENT";
    OBJECT_CATEGORY["TEAM"] = "TEAM";
    OBJECT_CATEGORY["DASHBOARD"] = "DASHBOARD";
    OBJECT_CATEGORY["WORKFLOW"] = "WORKFLOW";
    OBJECT_CATEGORY["ACTIVITY_REPORT"] = "ACTIVITY_REPORT";
    OBJECT_CATEGORY["DOCUMENT"] = "DOCUMENT";
    OBJECT_CATEGORY["TRANSFORMATION"] = "TRANSFORMATION";
    OBJECT_CATEGORY["STREAM"] = "STREAM";
    OBJECT_CATEGORY["NOTIFICATION"] = "NOTIFICATION";
    OBJECT_CATEGORY["NOTE"] = "NOTE";
    OBJECT_CATEGORY["ACTIVITY"] = "ACTIVITY";
    OBJECT_CATEGORY["REPORT"] = "REPORT";
    OBJECT_CATEGORY["EMAILGENERATION"] = "EMAILGENERATION";
    OBJECT_CATEGORY["METAEXPRESSION"] = "METAEXPRESSION";
    OBJECT_CATEGORY["FOLDER"] = "FOLDER";
    OBJECT_CATEGORY["TERRITORY"] = "TERRITORY";
    OBJECT_CATEGORY["CLIENT_SETTINGS"] = "CLIENT_SETTINGS";
    OBJECT_CATEGORY["TRIGGER"] = "TRIGGER";
    OBJECT_CATEGORY["WEBHOOK"] = "WEBHOOK";
    OBJECT_CATEGORY["ORDER"] = "ORDER";
    OBJECT_CATEGORY["CALENDAR_EVENT"] = "CALENDAR_EVENT";
    OBJECT_CATEGORY["QUERY"] = "QUERY";
    OBJECT_CATEGORY["CREATE_ITEM_JOB"] = "CREATE_ITEM_JOB";
    OBJECT_CATEGORY["EDIT_ITEM_JOB"] = "EDIT_ITEM_JOB";
    OBJECT_CATEGORY["ROUTE"] = "ROUTE";
    OBJECT_CATEGORY["STOCK"] = "STOCK";
})(OBJECT_CATEGORY || (exports.OBJECT_CATEGORY = OBJECT_CATEGORY = {}));
var ACTION_TYPE;
(function (ACTION_TYPE) {
    ACTION_TYPE["CREATE"] = "CREATE";
    ACTION_TYPE["EDIT"] = "EDIT";
    ACTION_TYPE["DELETE"] = "DELETE";
    ACTION_TYPE["ARCHIVE"] = "ARCHIVE";
    ACTION_TYPE["RESTORE"] = "RESTORE";
    ACTION_TYPE["FETCH"] = "FETCH";
    ACTION_TYPE["ADVANCED_ACTION"] = "ADVANCED_ACTION";
    /** @deprecated Don't use this action type anymore*/
    ACTION_TYPE["VERIFY"] = "VERIFY";
})(ACTION_TYPE || (exports.ACTION_TYPE = ACTION_TYPE = {}));
var DETAILED_OBJECT_CATEGORY;
(function (DETAILED_OBJECT_CATEGORY) {
    DETAILED_OBJECT_CATEGORY["MOB_USER"] = "MOB_USER";
    DETAILED_OBJECT_CATEGORY["WEB_USER"] = "WEB_USER";
    DETAILED_OBJECT_CATEGORY["LIST"] = "LIST";
    DETAILED_OBJECT_CATEGORY["ITEM"] = "ITEM";
    DETAILED_OBJECT_CATEGORY["CLIENT"] = "CLIENT";
    DETAILED_OBJECT_CATEGORY["TEAM"] = "TEAM";
    DETAILED_OBJECT_CATEGORY["CLIENT_PICTURE"] = "CLIENT_PICTURE";
    DETAILED_OBJECT_CATEGORY["DASHBOARD"] = "DASHBOARD";
    DETAILED_OBJECT_CATEGORY["WORKFLOW"] = "WORKFLOW";
    DETAILED_OBJECT_CATEGORY["ACTIVITY"] = "ACTIVITY";
    DETAILED_OBJECT_CATEGORY["DOCUMENT"] = "DOCUMENT";
    DETAILED_OBJECT_CATEGORY["SCRIPT"] = "SCRIPT";
    DETAILED_OBJECT_CATEGORY["STREAM"] = "STREAM";
    DETAILED_OBJECT_CATEGORY["TRANSFORMATION"] = "TRANSFORMATION";
    DETAILED_OBJECT_CATEGORY["NOTIFICATION"] = "NOTIFICATION";
    DETAILED_OBJECT_CATEGORY["NOTE"] = "NOTE";
    DETAILED_OBJECT_CATEGORY["HTTP_REQUEST"] = "HTTP_REQUEST";
    DETAILED_OBJECT_CATEGORY["ACTIVITY_REPORT"] = "ACTIVITY_REPORT";
    DETAILED_OBJECT_CATEGORY["VISIT_REPORT"] = "VISIT_REPORT";
    DETAILED_OBJECT_CATEGORY["INTEGRATION"] = "INETGRATION";
    DETAILED_OBJECT_CATEGORY["EMAILGENERATION"] = "EMAILGENERATION";
    DETAILED_OBJECT_CATEGORY["METAEXPRESSION"] = "METAEXPRESSION";
    DETAILED_OBJECT_CATEGORY["FOLDER"] = "FOLDER";
    DETAILED_OBJECT_CATEGORY["TERRITORY"] = "TERRITORY";
    DETAILED_OBJECT_CATEGORY["CALENDAR_EVENT"] = "CALENDAR_EVENT";
    DETAILED_OBJECT_CATEGORY["CREATE_ITEM_JOB"] = "CREATE_ITEM_JOB";
    DETAILED_OBJECT_CATEGORY["EDIT_ITEM_JOB"] = "EDIT_ITEM_JOB";
    DETAILED_OBJECT_CATEGORY["WEB_ACCESS_RIGHT_PROFILE"] = "WEB_ACCESS_RIGHT_PROFILE";
    DETAILED_OBJECT_CATEGORY["MOBILE_ACCESS_RIGHT_PROFILE"] = "MOBILE_ACCESS_RIGHT_PROFILE";
})(DETAILED_OBJECT_CATEGORY || (exports.DETAILED_OBJECT_CATEGORY = DETAILED_OBJECT_CATEGORY = {}));
var DETAILED_ACTION_TYPE;
(function (DETAILED_ACTION_TYPE) {
    DETAILED_ACTION_TYPE["CREATE"] = "CREATE";
    DETAILED_ACTION_TYPE["EDIT"] = "EDIT";
    DETAILED_ACTION_TYPE["DELETE"] = "DELETE";
    DETAILED_ACTION_TYPE["DOWNLOAD"] = "DOWNLOAD";
    DETAILED_ACTION_TYPE["ARCHIVE"] = "ARCHIVE";
    DETAILED_ACTION_TYPE["RESTORE"] = "RESTORE";
    DETAILED_ACTION_TYPE["FETCH"] = "FETCH";
    DETAILED_ACTION_TYPE["LICENSE"] = "LICENSE";
    DETAILED_ACTION_TYPE["UNLICENSE"] = "UNLICENSE";
    DETAILED_ACTION_TYPE["RUN"] = "RUN";
    DETAILED_ACTION_TYPE["UPLOAD_FILE_FOR"] = "UPLOAD_FILE_FOR";
    DETAILED_ACTION_TYPE["ASSIGN"] = "ASSIGN";
    DETAILED_ACTION_TYPE["UNASSIGN"] = "UNASSIGN";
    DETAILED_ACTION_TYPE["REPLICATE"] = "REPLICATE";
})(DETAILED_ACTION_TYPE || (exports.DETAILED_ACTION_TYPE = DETAILED_ACTION_TYPE = {}));
exports.DETAILED_ACTION_CODE = {
    // Authentication
    OTP: "OTP",
    Signup: "SIGNUP",
    GoogleLogin: "GOOGLE_LOGIN",
    Login: "LOGIN",
    Logout: "LOGOUT",
    PasswordRequest: "PASSWORD_REQUEST",
    ChangePassword: "CHANGE_PASSWORD",
    ResetPassword: "RESET_PASSWORD",
    // ACTIVITY REPORT
    Submit: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    UploadFileForActivityReport: `${DETAILED_ACTION_TYPE.UPLOAD_FILE_FOR}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    FetchActivityReports: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}S`,
    FetchActivityReport: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    EditActivityReport: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    DeleteActivityReport: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    FetchPictures: `${DETAILED_ACTION_TYPE.FETCH}_PICTURES`,
    UploadFileForTaskActivityReports: `${DETAILED_ACTION_TYPE.UPLOAD_FILE_FOR}_TASK_ACTIVITY_REPORTS`,
    // item management
    FetchItems: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.ITEM}S`,
    CreateItem: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.ITEM}`,
    CreateItems: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.ITEM}S`,
    DeleteItem: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.ITEM}`,
    DeleteItems: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.ITEM}S`,
    ArchiveItem: `${DETAILED_ACTION_TYPE.ARCHIVE}_${DETAILED_OBJECT_CATEGORY.ITEM}`,
    ArchiveItems: `${DETAILED_ACTION_TYPE.ARCHIVE}_${DETAILED_OBJECT_CATEGORY.ITEM}S`,
    RestoreItem: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.ITEM}`,
    RestoreItems: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.ITEM}S`,
    UpdateItem: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.ITEM}`,
    UpdateItems: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.ITEM}S`,
    UploadFileForItem: `${DETAILED_ACTION_TYPE.UPLOAD_FILE_FOR}_${DETAILED_OBJECT_CATEGORY.ITEM}`,
    AssignTeamsToItem: `${DETAILED_ACTION_TYPE.ASSIGN}_${DETAILED_OBJECT_CATEGORY.ITEM}S`,
    AssignItems: `${DETAILED_ACTION_TYPE.ASSIGN}_${DETAILED_OBJECT_CATEGORY.ITEM}S`,
    UnassignItems: `${DETAILED_ACTION_TYPE.UNASSIGN}_${DETAILED_OBJECT_CATEGORY.ITEM}S`,
    // list management
    FetchLists: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.LIST}S`,
    CreateList: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.LIST}`,
    ArchiveList: `${DETAILED_ACTION_TYPE.ARCHIVE}_${DETAILED_OBJECT_CATEGORY.LIST}`,
    RestoreList: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.LIST}`,
    DeleteList: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.LIST}`,
    UpdateList: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.LIST}`,
    FetchListIds: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.LIST}_IDS`,
    // workflow management
    FetchWorkflows: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}S`,
    CreateWorkflow: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}`,
    ArchiveWorkflow: `${DETAILED_ACTION_TYPE.ARCHIVE}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}`,
    RestoreWorkflow: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}`,
    DeleteWorkflow: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}`,
    UpdateWorkflow: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}`,
    UploadFileForWorkflow: `${DETAILED_ACTION_TYPE.UPLOAD_FILE_FOR}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}`,
    FetchWorkflowVersions: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}_VERSIONS`,
    RestoreWorkflowVersion: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}_VERSION`,
    // user management
    FetchMobUsers: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.MOB_USER}S`,
    FetchWebUsers: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.WEB_USER}S`,
    CreateMobUser: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.MOB_USER}`,
    CreateWebUser: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.WEB_USER}`,
    CreateMobUsers: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.MOB_USER}S`,
    CreateWebUsers: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.WEB_USER}S`,
    DeleteMobUser: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.MOB_USER}`,
    DeleteWebUser: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.WEB_USER}`,
    DeleteMobUsers: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.MOB_USER}S`,
    DeleteWebUsers: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.WEB_USER}S`,
    EditMobUser: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.MOB_USER}`,
    EditMobUsers: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.MOB_USER}S`,
    EditWebUser: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.WEB_USER}`,
    EditWebUsers: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.WEB_USER}S`,
    LicenseMobileUser: `${DETAILED_ACTION_TYPE.LICENSE}_${DETAILED_OBJECT_CATEGORY.MOB_USER}`,
    LicenseMobileUsers: `${DETAILED_ACTION_TYPE.LICENSE}_${DETAILED_OBJECT_CATEGORY.MOB_USER}S`,
    UnlicenseMobileUser: `${DETAILED_ACTION_TYPE.UNLICENSE}_${DETAILED_OBJECT_CATEGORY.MOB_USER}`,
    UnlicenseMobileUsers: `${DETAILED_ACTION_TYPE.UNLICENSE}_${DETAILED_OBJECT_CATEGORY.MOB_USER}S`,
    AssignMobileUsersToTeams: `${DETAILED_ACTION_TYPE.ASSIGN}_${DETAILED_OBJECT_CATEGORY.TEAM}S`,
    AssignWebUsersToTeams: `${DETAILED_ACTION_TYPE.ASSIGN}_${DETAILED_OBJECT_CATEGORY.TEAM}S`,
    CreateSuperAdmin: `CREATE_SUPER_ADMIN`,
    CreateDateChange: `${DETAILED_ACTION_TYPE.CREATE}_DATE_CHANGE`,
    UnlockLogin: `UNLOCK_LOGIN`,
    // team management
    FetchTeams: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.TEAM}S`,
    CreateTeam: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.TEAM}`,
    CreateTeams: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.TEAM}S`,
    EditTeams: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.TEAM}S`,
    DeleteTeams: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.TEAM}S`,
    ArchiveTeams: `${DETAILED_ACTION_TYPE.ARCHIVE}_${DETAILED_OBJECT_CATEGORY.TEAM}S`,
    RestoreTeams: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.TEAM}S`,
    AssignMobileUsersToTeam: `${DETAILED_ACTION_TYPE.ASSIGN}_${DETAILED_OBJECT_CATEGORY.TEAM}`,
    AssignWebUsersToTeam: `${DETAILED_ACTION_TYPE.ASSIGN}_${DETAILED_OBJECT_CATEGORY.TEAM}`,
    // transformation management
    FetchTransformations: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.TRANSFORMATION}S`,
    CreateTransformation: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.TRANSFORMATION}`,
    DeleteTransformation: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.TRANSFORMATION}`,
    EditTransformation: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.TRANSFORMATION}`,
    RunTransformation: `${DETAILED_ACTION_TYPE.RUN}_${DETAILED_OBJECT_CATEGORY.TRANSFORMATION}`,
    // stream management
    FetchStreams: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.STREAM}S`,
    CreateStream: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.STREAM}`,
    DeleteStream: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.STREAM}`,
    EditStream: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.STREAM}`,
    UseStream: `${DETAILED_ACTION_TYPE.RUN}_${DETAILED_OBJECT_CATEGORY.STREAM}`,
    // script management
    FetchScripts: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.SCRIPT}S`,
    CreateScript: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.SCRIPT}`,
    DeleteScript: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.SCRIPT}`,
    EditScript: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.SCRIPT}`,
    UseScript: `${DETAILED_ACTION_TYPE.RUN}_${DETAILED_OBJECT_CATEGORY.SCRIPT}`,
    // notification management
    FetchNotifications: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.NOTIFICATION}S`,
    CreateNotification: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.NOTIFICATION}`,
    DeleteNotification: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.NOTIFICATION}`,
    EditNotification: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.NOTIFICATION}`,
    // create item job
    FetchCreateItemJobs: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.CREATE_ITEM_JOB}S`,
    CreateCreateItemJob: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.CREATE_ITEM_JOB}`,
    DeleteCreateItemJob: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.CREATE_ITEM_JOB}`,
    EditCreateItemJob: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.CREATE_ITEM_JOB}`,
    RunCreateItemJob: `${DETAILED_ACTION_TYPE.RUN}_${DETAILED_OBJECT_CATEGORY.CREATE_ITEM_JOB}`,
    // edit item job
    FetchEditItemJobs: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.EDIT_ITEM_JOB}S`,
    CreateEditItemJob: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.EDIT_ITEM_JOB}`,
    DeleteEditItemJob: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.EDIT_ITEM_JOB}`,
    EditEditItemJob: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.EDIT_ITEM_JOB}`,
    RunEditItemJob: `${DETAILED_ACTION_TYPE.RUN}_${DETAILED_OBJECT_CATEGORY.EDIT_ITEM_JOB}`,
    // note management
    FetchNotes: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.NOTE}S`,
    CreateNote: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.NOTE}`,
    DeleteNote: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.NOTE}`,
    EditNote: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.NOTE}`,
    // integration management
    FetchIntegrations: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.INTEGRATION}S`,
    CreateIntegration: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.INTEGRATION}`,
    DeleteIntegration: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.INTEGRATION}`,
    EditIntegration: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.INTEGRATION}`,
    SendWebhookCallbacksData: "SEND_WEBHOOK_CALLBACK_DATA",
    // client management
    FetchClient: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.CLIENT}`,
    FetchClients: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.CLIENT}S`,
    CreateClient: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.CLIENT}`,
    ArchiveClient: `${DETAILED_ACTION_TYPE.ARCHIVE}_${DETAILED_OBJECT_CATEGORY.CLIENT}`,
    RestoreClient: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.CLIENT}`,
    DeleteClient: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.CLIENT}`,
    EditClient: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.CLIENT}`,
    EditTeamsHierarchy: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.TEAM}S_HIERARCHY`,
    UploadClientPicture: "UPLOAD_CLIENT_PICTURE",
    GetLicenseStatus: "GET_LICENSE_STATUS",
    ExportClientData: "EXPORT_CLIENT_DATA",
    FetchDbUser: `${DETAILED_ACTION_TYPE.FETCH}_DB_USER`,
    GoLive: `GO_LIVE`,
    //Billing
    CreateSubscription: "CREATE_SUBSCRIPTION",
    CancelSubscription: "CANCEL_SUBSCRIPTION",
    ResumeSubscription: "RESUME_SUBSCRIPTION",
    // dashboard management
    FetchDashboard: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.DASHBOARD}`,
    FetchDashboards: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.DASHBOARD}S`,
    ArchiveDashboards: `${DETAILED_ACTION_TYPE.ARCHIVE}_${DETAILED_OBJECT_CATEGORY.DASHBOARD}S`,
    RestoreDashboards: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.DASHBOARD}S`,
    CreateDashboard: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.DASHBOARD}`,
    DeleteDashboard: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.DASHBOARD}`,
    ComputeDashboard: `${DETAILED_ACTION_TYPE.RUN}_${DETAILED_OBJECT_CATEGORY.DASHBOARD}`,
    EditDashboard: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.DASHBOARD}`,
    ComputeDefaultDashboard: `${DETAILED_ACTION_TYPE.RUN}_DEFAULT_DASHBOARD`,
    GetUserReport: `GET_USER_REPORT`,
    GetRecapReport: `GET_RECAP_REPORT`,
    // uploads
    GetClientPictures: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.CLIENT}_PICTURES`,
    UploadFiles: `UPLOAD_FILES`,
    // documents
    GetDocuments: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.DOCUMENT}S`,
    CreateDocument: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.DOCUMENT}`,
    EditDocument: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.DOCUMENT}`,
    DeleteDocument: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.DOCUMENT}`,
    // GPS recording
    RecordUserLocations: "RECORD_USER_LOCATION",
    // profile
    EditProfile: "EDIT_PROFILE",
    GetProfile: "GET_PROFILE",
    UploadProfilePicture: `UPLOAD_PROFILE_PICTURE`,
    // activity management
    FetchActivities: `${DETAILED_ACTION_TYPE.FETCH}_ACTIVITIES`,
    FetchWorkflowActivities: `${DETAILED_ACTION_TYPE.FETCH}_WORKFLOW_ACTIVITIES`,
    CreateActivity: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    ArchiveActivity: `${DETAILED_ACTION_TYPE.ARCHIVE}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    RestoreActivity: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    DeleteActivity: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    UpdateActivity: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    FetchActivityVersions: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}_VERSIONS`,
    RestoreActivityVersion: `${DETAILED_ACTION_TYPE.RESTORE}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}_VERSION`,
    // Reports
    CreateReport: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    EditReport: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    FetchReports: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}S`,
    CreateWorkflowReport: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    EditWorkflowReport: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    FetchWorkflowReports: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.WORKFLOW}_${DETAILED_OBJECT_CATEGORY.ACTIVITY_REPORT}S`,
    //Visit Report
    FetchVisitReports: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.VISIT_REPORT}S`,
    CreateVisitReport: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.VISIT_REPORT}`,
    // Other
    LogError: "LOG_ERROR",
    GetDeltaFirestorePostgres: "GET_DELTA_FIRESTORE_POSTGRES",
    CleanupFirestoreGcsUrls: "CLEANUP_FIRESTORE_GCS_URLS",
    OtherAction: "OTHER_ACTION",
    CheckWebAppUpdate: "CHECK_WEB_APP_UPDATE",
    COMPUTE: "COMPUTE",
    ComputeBestPathForVisits: "COMPUTE_BEST_PATH_FOR_VISITS",
    CreateImageDetection: "CREATE_IMAGE_DETECTION",
    //Customer Actions
    CUSTOMER_OTP: "CUSTOMER_OTP",
    CUSTOMER_SIGNUP: "CUSTOMER_SIGNUP",
    CUSTOMER_LOGIN: "CUSTOMER_LOGIN",
    CUSTOMER_LOGOUT: "CUSTOMER_LOGOUT",
    CUSTOMER_FETCH_CLIENTS: "CUSTOMER_FETCH_CLIENTS",
    CUSTOMER_FETCH_ORDERS: "CUSTOMER_FETCH_ORDERS",
    //Calendar Events Actions
    CreateCalendarEvent: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.CALENDAR_EVENT}`,
    EditCalendarEvent: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.CALENDAR_EVENT}`,
    DeleteCalendarEvent: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.CALENDAR_EVENT}`,
    FetchCalendarEvents: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.CALENDAR_EVENT}S`,
    //orders
    FetchOrder: `${DETAILED_ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.ORDER}`,
    // Stock management
    CreateStockMovement: `${DETAILED_ACTION_TYPE.CREATE}_STOCK_MOVEMENT`,
    FetchStock: `${DETAILED_ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.STOCK}`,
    FetchStorage: `${DETAILED_ACTION_TYPE.FETCH}_STORAGE`,
};
/**
 * Action code (for access right management)
 */
exports.ACTION_CODE = {
    // basic
    BASIC: "BASIC",
    SUPER_ADMIN: "SUPER_ADMIN",
    RECORD_USER_LOCATION: "RECORD_USER_LOCATION",
    // authentication
    OTP: "OTP",
    GOOGLE_LOGIN: "GOOGLE_LOGIN",
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    // activity reports
    CREATE_ACTIVITY_REPORT: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    FETCH_ACTIVITY_REPORT: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    EDIT_ACTIVITY_REPORT: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    DELETE_ACTIVITY_REPORT: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    ADVANCED_ACTION_ACTIVITY_REPORT: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.ACTIVITY_REPORT}`,
    // items
    FETCH_ITEM: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.ITEM}`,
    CREATE_ITEM: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.ITEM}`,
    DELETE_ITEM: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.ITEM}`,
    ARCHIVE_ITEM: `${ACTION_TYPE.ARCHIVE}_${OBJECT_CATEGORY.ITEM}`,
    RESTORE_ITEM: `${ACTION_TYPE.RESTORE}_${OBJECT_CATEGORY.ITEM}`,
    EDIT_ITEM: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.ITEM}`,
    ADVANCED_ACTION_ITEM: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.ITEM}`,
    // lists
    FETCH_LIST: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.LIST}`,
    CREATE_LIST: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.LIST}`,
    ARCHIVE_LIST: `${ACTION_TYPE.ARCHIVE}_${OBJECT_CATEGORY.LIST}`,
    RESTORE_LIST: `${ACTION_TYPE.RESTORE}_${OBJECT_CATEGORY.LIST}`,
    DELETE_LIST: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.LIST}`,
    EDIT_LIST: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.LIST}`,
    ADVANCED_ACTION_LIST: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.LIST}`,
    // workflows
    FETCH_WORKFLOW: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.WORKFLOW}`,
    CREATE_WORKFLOW: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.WORKFLOW}`,
    ARCHIVE_WORKFLOW: `${ACTION_TYPE.ARCHIVE}_${OBJECT_CATEGORY.WORKFLOW}`,
    RESTORE_WORKFLOW: `${ACTION_TYPE.RESTORE}_${OBJECT_CATEGORY.WORKFLOW}`,
    DELETE_WORKFLOW: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.WORKFLOW}`,
    EDIT_WORKFLOW: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.WORKFLOW}`,
    ADVANCED_ACTION_WORKFLOW: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.WORKFLOW}`,
    // activities (currently used in mobile only, not in web)
    FETCH_ACTIVITY: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.ACTIVITY}`,
    CREATE_ACTIVITY: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.ACTIVITY}`,
    ARCHIVE_ACTIVITY: `${ACTION_TYPE.ARCHIVE}_${OBJECT_CATEGORY.ACTIVITY}`,
    RESTORE_ACTIVITY: `${ACTION_TYPE.RESTORE}_${OBJECT_CATEGORY.ACTIVITY}`,
    DELETE_ACTIVITY: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.ACTIVITY}`,
    EDIT_ACTIVITY: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.ACTIVITY}`,
    ADVANCED_ACTION_ACTIVITY: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.ACTIVITY}`,
    // users
    FETCH_MOB_USER: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.MOB_USER}`,
    FETCH_WEB_USER: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.WEB_USER}`,
    CREATE_MOB_USER: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.MOB_USER}`,
    CREATE_WEB_USER: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.WEB_USER}`,
    DELETE_MOB_USER: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.MOB_USER}`,
    DELETE_WEB_USER: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.WEB_USER}`,
    EDIT_MOB_USER: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.MOB_USER}`,
    EDIT_WEB_USER: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.WEB_USER}`,
    ADVANCED_ACTION_MOB_USER: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.MOB_USER}`,
    ADVANCED_ACTION_WEB_USER: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.WEB_USER}`,
    CREATE_SUPER_ADMIN: `CREATE_SUPER_ADMIN`,
    // teams
    FETCH_TEAM: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.TEAM}`,
    CREATE_TEAM: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.TEAM}`,
    EDIT_TEAM: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.TEAM}`,
    DELETE_TEAM: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.TEAM}`,
    ARCHIVE_TEAM: `${ACTION_TYPE.ARCHIVE}_${OBJECT_CATEGORY.TEAM}`,
    RESTORE_TEAM: `${ACTION_TYPE.RESTORE}_${OBJECT_CATEGORY.TEAM}`,
    ADVANCED_ACTION_TEAM: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.TEAM}`,
    // clients
    FETCH_CLIENT: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.CLIENT}`,
    CREATE_CLIENT: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.CLIENT}`,
    ARCHIVE_CLIENT: `${ACTION_TYPE.ARCHIVE}_${OBJECT_CATEGORY.CLIENT}`,
    RESTORE_CLIENT: `${ACTION_TYPE.RESTORE}_${OBJECT_CATEGORY.CLIENT}`,
    DELETE_CLIENT: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.CLIENT}`,
    EDIT_CLIENT: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.CLIENT}`,
    ADVANCED_ACTION_CLIENT: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.CLIENT}`,
    // dashboards
    FETCH_DASHBOARD: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.DASHBOARD}`,
    ARCHIVE_DASHBOARD: `${ACTION_TYPE.ARCHIVE}_${OBJECT_CATEGORY.DASHBOARD}`,
    RESTORE_DASHBOARD: `${ACTION_TYPE.RESTORE}_${OBJECT_CATEGORY.DASHBOARD}`,
    CREATE_DASHBOARD: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.DASHBOARD}`,
    DELETE_DASHBOARD: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.DASHBOARD}`,
    EDIT_DASHBOARD: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.DASHBOARD}`,
    ADVANCED_ACTION_DASHBOARD: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.DASHBOARD}`,
    VIEW_DEFAULT_DASHBOARDS: "VIEW_DEFAULT_DASHBOARDS",
    EXPORT_CLIENT_DATA: "EXPORT_CLIENT_DATA",
    // documents
    FETCH_DOCUMENT: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.DOCUMENT}`,
    CREATE_DOCUMENT: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.DOCUMENT}`,
    EDIT_DOCUMENT: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.DOCUMENT}`,
    DELETE_DOCUMENT: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.DOCUMENT}`,
    ADVANCED_ACTION_DOCUMENT: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.DOCUMENT}`,
    // notes
    FETCH_NOTE: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.NOTE}`,
    CREATE_NOTE: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.NOTE}`,
    EDIT_NOTE: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.NOTE}`,
    DELETE_NOTE: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.NOTE}`,
    ADVANCED_ACTION_NOTE: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.NOTE}`,
    // territories
    FETCH_TERRITORY: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.TERRITORY}`,
    CREATE_TERRITORY: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.TERRITORY}`,
    DELETE_TERRITORY: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.TERRITORY}`,
    EDIT_TERRITORY: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.TERRITORY}`,
    ADVANCED_ACTION_TERRITORY: `${ACTION_TYPE.ADVANCED_ACTION}_${OBJECT_CATEGORY.TERRITORY}`,
    // client settings
    /** LEGACY, use FETCH_CLIENT_SETTINGS */
    VIEW_CLIENT_SETTINGS: "VIEW_CLIENT_SETTINGS",
    FETCH_CLIENT_SETTINGS: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.CLIENT_SETTINGS}`,
    EDIT_CLIENT_SETTINGS: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.CLIENT_SETTINGS}`,
    // calendar events
    CREATE_CALENDAR_EVENT: `${DETAILED_ACTION_TYPE.CREATE}_${DETAILED_OBJECT_CATEGORY.CALENDAR_EVENT}`,
    EDIT_CALENDAR_EVENT: `${DETAILED_ACTION_TYPE.EDIT}_${DETAILED_OBJECT_CATEGORY.CALENDAR_EVENT}`,
    DELETE_CALENDAR_EVENT: `${DETAILED_ACTION_TYPE.DELETE}_${DETAILED_OBJECT_CATEGORY.CALENDAR_EVENT}`,
    FETCH_CALENDAR_EVENT: `${DETAILED_ACTION_TYPE.FETCH}_${DETAILED_OBJECT_CATEGORY.CALENDAR_EVENT}`,
    // web orders
    FETCH_ORDER: `${ACTION_TYPE.FETCH}_${OBJECT_CATEGORY.ORDER}`,
    CREATE_ORDER: `${ACTION_TYPE.CREATE}_${OBJECT_CATEGORY.ORDER}`,
    EDIT_ORDER: `${ACTION_TYPE.EDIT}_${OBJECT_CATEGORY.ORDER}`,
    DELETE_ORDER: `${ACTION_TYPE.DELETE}_${OBJECT_CATEGORY.ORDER}`,
    // customers api
    CUSTOMER_OTP: "CUSTOMER_OTP",
    CUSTOMER_SIGNUP: "CUSTOMER_SIGNUP",
    CUSTOMER_LOGIN: "CUSTOMER_LOGIN",
    CUSTOMER_LOGOUT: "CUSTOMER_LOGOUT",
    FETCH_CUSTOMER_CLIENTS: `${ACTION_TYPE.FETCH}_CUSTOMER_${OBJECT_CATEGORY.CLIENT}S`,
    FETCH_CUSTOMER_ORDERS: `${ACTION_TYPE.FETCH}_CUSTOMER_${OBJECT_CATEGORY.ORDER}S`,
    FETCH_CUSTOMER_PROFILE: "FETCH_CUSTOMER_PROFILE",
    // pictures
    FETCH_CLIENT_PICTURE: "FETCH_CLIENT_PICTURE",
    /** @deprecated Don't use this action code anymore*/
    VERIFY_QUERY: "VERIFY_QUERY",
    EDIT_QUERY: "EDIT_QUERY",
    FETCH_STOCK: "FETCH_STOCK",
    CREATE_STOCK: "CREATE_STOCK",
    EDIT_STOCK: "EDIT_STOCK",
    CREATE_STOCK_MOVEMENT: "CREATE_STOCK_MOVEMENT",
    FETCH_STORAGE: "FETCH_STORAGE",
};
